'use client';

import { ToastContext } from '@contexts/ToastContext';
import {
  onFacebook,
  onKakao,
  urlToClipboard,
} from '@wconcept/wconcept-common/utils/sns';
import { useCallback, useContext } from 'react';
import { isAndroid } from 'react-device-detect';

const COPY_TOAST_MESSAGE = '클립보드에 복사되었습니다.';

interface UseShareSnsOptions {
  /** 지정 시 URL 복사 토스트를 ToastContext 대신 해당 콜백으로 표시 (프로모션 GlobalToastPopup 등) */
  onCopyToast?: (message: string) => void;
}

const useShareSns = ({ onCopyToast }: UseShareSnsOptions = {}) => {
  const { openToast } = useContext(ToastContext);

  const shareFacebook = useCallback(
    (
      isNativeAppBoth: boolean,
      isMobile: boolean,
      { targetUrl }: { targetUrl: string }
    ) => {
      onFacebook(targetUrl || window.location.href, isNativeAppBoth, !isMobile);
    },
    []
  );

  const shareKakao = useCallback(
    (
      title: string,
      isNativeAppBoth: boolean,
      isMobile: boolean,
      { targetUrl }: { targetUrl: string }
    ) => {
      onKakao(
        title,
        targetUrl || window.location.href,
        isNativeAppBoth,
        !isMobile
      );
    },
    []
  );

  const onUrlClipboard = useCallback(
    ({
      isMobile,
      targetUrl,
      isAppLanding,
      onCopyToast: onCopyToastOverride,
    }: {
      isMobile: boolean;
      device: 'iOS' | 'PC' | 'Andriod' | 'Mobile' | string;
      isNativeAppBoth: boolean;
      targetUrl?: string;
      isAppLanding?: boolean;
      onCopyToast?: (message: string) => void;
    }) => {
      const currentUrl = targetUrl || window.location.href;
      const url = new URL(currentUrl);

      if (isAppLanding) {
        if (!url.searchParams.has('applanding')) {
          url.searchParams.set('applanding', 'Y');
        }
      } else {
        url.searchParams.delete('applanding');
      }

      const newUrl = url.toString();
      const showCopyToast = onCopyToastOverride ?? onCopyToast ?? openToast;

      urlToClipboard(`${newUrl}`).then(() => {
        if (isMobile) {
          if (!isAndroid) {
            showCopyToast(COPY_TOAST_MESSAGE);
          }
        } else {
          window.alert(COPY_TOAST_MESSAGE);
        }
      });
    },
    [onCopyToast, openToast]
  );

  return {
    shareFacebook,
    shareKakao,
    onUrlClipboard,
  };
};

export default useShareSns;
